module.exports = __webpack_public_path__ + "img/afrochampions.bb553ed2.png";